var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWerke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.7485C18 17.5135 17.38 18.1335 16.615 18.1335C15.851 18.1335 15.23 17.5135 15.23 16.7485V13.5185C15.23 12.7535 15.851 12.1335 16.615 12.1335C17.38 12.1335 18 12.7535 18 13.5185V16.7485ZM13.385 16.7485C13.385 17.5135 12.765 18.1335 12 18.1335C11.235 18.1335 10.615 17.5135 10.615 16.7485V13.5185C10.615 12.7535 11.235 12.1335 12 12.1335C12.765 12.1335 13.385 12.7535 13.385 13.5185V16.7485ZM8.77 16.7485C8.77 17.5135 8.149 18.1335 7.385 18.1335C6.62 18.1335 6 17.5135 6 16.7485V13.5185C6 12.7535 6.62 12.1335 7.385 12.1335C8.149 12.1335 8.77 12.7535 8.77 13.5185V16.7485ZM12 7.13352V4.00152C12 3.20352 11.109 2.72652 10.445 3.16952L3.891 6.53952C3.334 6.91052 3 7.53552 3 8.20352V19.1335C3 20.2375 3.896 21.1335 5 21.1335H19C20.104 21.1335 21 20.2375 21 19.1335V4.00152C21 3.20352 20.109 2.72652 19.445 3.16952L12 7.13352Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWerke);
export default __webpack_public_path__ + "static/media/werke.48ce0538b27ab87fe830f28c1a74cce7.svg";
export { ForwardRef as ReactComponent };